import type { LegacyRef } from 'react'

import Skeleton from '@mui/material/Skeleton'

import css from './Thumbnail.module.css'

export function ThumbnailSkeleton({
	innerRef
}: { innerRef?: LegacyRef<HTMLLIElement> }) {
	return (
		<li className={css.root} ref={innerRef}>
			<Skeleton
				className={css.avatar}
				height='3.5rem'
				variant='circular'
				width='3.5rem'
			/>

			<Skeleton
				className={css.title}
				height={'1.25em'}
				variant='text'
				width='20ch'
			/>
			<div className={css.skeletonBody}>
				<Skeleton className={css.body} variant='text' width='100%' />
				<Skeleton className={css.body} variant='text' width='100%' />
			</div>
		</li>
	)
}
